import React from 'react';
import FormButton from '@app/component/form/button/FormButton';


const ErrorPageNotFound = React.memo(() => {

    return <div className="min-h-full bg-white py-16 px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
        <div className="mx-auto max-w-max">
            <main className="sm:flex">
                <p className="text-4xl font-bold tracking-tight text-blue-600 sm:text-8xl">404</p>
                <div className="sm:ml-6">
                    <div className="sm:border-l sm:border-slate-200 sm:pl-6">
                        <h1 className="text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">Page not found</h1>
                        <p className="mt-1 text-base text-slate-500">Please check the URL in the address bar and try
                            again.</p>
                    </div>
                    <div className="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
                        <FormButton to="/secured/dashboard" state='primary'>
                            Go back home
                        </FormButton>
                        <FormButton to="/" state='white'>
                            Contact support
                        </FormButton>
                    </div>
                </div>
            </main>
        </div>
    </div>
})

export default ErrorPageNotFound;